module.exports = __webpack_public_path__ + "static/media/contact.08effa4e.png";